export default __webpack_public_path__ + "static/media/cardDestaques.fdde2177.svg";